
<script>
  import UseResource from 'components/svg/UseResource.svelte';

  export let icon;
  export let active = false;
  export let title = 'missing title';
</script>

<button class="circle-btn"
        class:circle-btn--active={active}
        on:click
        {title}
        type="button">
  <span class="circle">
    <UseResource name={icon} />
  </span>
  {#if $$slots.default}
    <span class="text"><slot></slot></span>
  {/if}
</button>

<style>
  .circle-btn {
    position: relative;
    display: flex;

    justify-content: center;
    align-items: center;

    background: transparent;
    border: none;
    color: inherit;
    font-family: inherit;
    outline: none;
  }

  .circle {
    --background: var(--highlight);
    --border: none;

    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 60px;
    height: 60px;

    justify-content: center;
    align-items: center;

    overflow: hidden;

    background: var(--background, none);
    border: var(--border);
    border-radius: 50%;
    color: inherit;
    font-family: inherit;
  }

  .circle > :global(.resource) {
    --filter: var(--normal-filter, invert(100%));
    filter: var(--filter);
  }

  .circle-btn--active .circle {
    --background: var(--content-bg);
    --border-color: var(--highlight);
    --border: 4px solid var(--border-color);

    width: 80px;
    height: 80px;

    background: var(--background);
    border: var(--border);

    z-index: 10;
  }

  .circle-btn--active .circle > :global(.resource) {
    --filter: var(--highlight-filter, invert(0));
    filter: var(--filter);
  }

  .text {
    margin-left: 16px;
    font-size: 20px;
  }

</style>
